import { BrowserRouter, Route, Routes, Navigate, Outlet } from 'react-router-dom';
import Home from './components/home/Home';
import Navbar from './components/navigation/Navbar';
import ContactUs from './components/pages/ContactUs';
import Products from './components/pages/Products';
import Register from './components/users/Register';
import EditUser from './components/users/EditUser';
import EditPass from './components/users/EditPassword';
import EditUserByAdmin from './components/users/EditUserByAdmin';
import UserList from './components/users/UserList';
import Services from './components/pages/Services';
import Login from './components/login/Login';
import './App.css';

import AddCarriage from './components/carriage/AddCarriage';
import EditCarriage from './components/carriage/EditCarriage';
import AddSoldCarriage from './components/soldCarriage/AddSoldCarriage';
import EditSoldCarriage from './components/soldCarriage/EditSoldCarriage';
import CarriageList from './components/carriage/CarriageList';
import SoldCarriageList from './components/soldCarriage/SoldCarriageList';
import SoldCarriageList2Print from './components/soldCarriage/SoldCarriageList2Print';
import CarriageList2Print from './components/carriage/CarriageList2Print';
import CarriagePaletteList2Print from './components/palette_carriage/CarriagePaletteList2Print';

import AddCar from './components/cars/AddCar';
import CarsList from './components/cars/CarsList';
import EditCar from './components/cars/EditCar';
import ClientsList from './components/clients/ClientsList';
import AddClient from './components/clients/AddClient';
import EditClient from './components/clients/EditClient';
import AddDriver from './components/drivers/AddDriver';
import DriversList from './components/drivers/DriversList';
import EditDriver from './components/drivers/EditDriver';
import EditCarriagePalette from './components/palette_carriage/EditCarriagePalette';
import AddCarriagePalette from './components/palette_carriage/AddCarriagePalette';
import CarriagePaletteList from './components/palette_carriage/CarriagePaletteList';
import CarriagePaletteClientsList from './components/palette_carriage/CarriagePaletteClientsList';
import AuditLog from './components/AuditLog/AuditLog';
import Statistics from './components/statistics';
import InvoiceList from './components/Invoice/InvoiceList';
import { useAuthContext } from './hooks/useAuthContext';
import Notes from './components/Notes';
import NoteCreate from './components/Notes/NoteCreate';
import NoteEdit from './components/Notes/NoteEdit';
import CarriageNotes from './components/CarriageNotes';
import CarriageNoteCreate from './components/CarriageNotes/NoteCreate';
import CarriageNoteEdit from './components/CarriageNotes/NoteEdit';

function App() {
  const { user, authReady } = useAuthContext();

  const requireLogin = (Component) => {
    if (!authReady) return null;
    if (!user) {
      return <Navigate to='/login' replace />;
    }
    return <Component />;
  };

  return (
    <BrowserRouter>
      <Routes>
        <Route
          exact
          element={
            <>
              <Navbar />
              <Outlet />
            </>
          }
        >
          <Route index exact element={<Home />} />
          <Route path='/services' element={requireLogin(Services)} />
          <Route path='/products' element={requireLogin(Products)} />
          <Route path='/users' element={requireLogin(Register)} />
          <Route path='/contact-us' element={<ContactUs />} />
          <Route path='/login' element={!authReady ? null : user ? <Navigate to='/' replace /> : <Login />} />

          {/* carriage */}
          <Route path='/carriageList' element={requireLogin(CarriageList)} />
          <Route path='/addCarriage' element={requireLogin(AddCarriage)} />
          <Route path='/editCarriage' element={requireLogin(EditCarriage)} />
          <Route path='/soldCarriageList' element={requireLogin(SoldCarriageList)} />

          <Route path='/addSoldCarriage' element={requireLogin(AddSoldCarriage)} />
          <Route path='/editSoldCarriage' element={requireLogin(EditSoldCarriage)} />
          {/* carriage */}
          <Route path='/carriagePaletteList' element={requireLogin(CarriagePaletteList)} />
          <Route path='/editCarriagePalette' element={requireLogin(EditCarriagePalette)} />
          <Route path='/addCarriagePalette' element={requireLogin(AddCarriagePalette)} />
          <Route path='/carriagePaletteClientsList' element={requireLogin(CarriagePaletteClientsList)} />

          <Route path='/invoiceList' element={requireLogin(InvoiceList)} />

          {/* cars */}
          <Route path='/carsList' element={requireLogin(CarsList)} />
          <Route path='/addCar' element={requireLogin(AddCar)} />
          <Route path='/editCar' element={requireLogin(EditCar)} />

          {/* drivers */}
          <Route path='/driversList' element={requireLogin(DriversList)} />
          <Route path='/addDriver' element={requireLogin(AddDriver)} />
          <Route path='/editDriver' element={requireLogin(EditDriver)} />

          {/* clients */}
          <Route path='/clientsList' element={requireLogin(ClientsList)} />
          <Route path='/addClient' element={requireLogin(AddClient)} />
          <Route path='/editClient' element={requireLogin(EditClient)} />
          {/* users */}
          <Route path='/register' element={requireLogin(Register)} />
          <Route path='/editUser' element={requireLogin(EditUser)} />
          <Route path='/editPass' element={requireLogin(EditPass)} />
          <Route path='/editUserByAdmin' element={requireLogin(EditUserByAdmin)} />
          <Route path='/userList' element={requireLogin(UserList)} />
          {/* Statisctics */}
          <Route path='/statistics' element={requireLogin(Statistics)} />
          {/* Notes */}
          <Route path='/notes' element={requireLogin(Notes)} />
          <Route path='/notes/create' element={requireLogin(NoteCreate)} />
          <Route path='/notes/:id' element={requireLogin(NoteEdit)} />
          {/* Carriage Notes */}
          <Route path='/carriageNotes' element={requireLogin(CarriageNotes)} />
          <Route path='/carriageNotes/create' element={requireLogin(CarriageNoteCreate)} />
          <Route path='/carriageNotes/:id' element={requireLogin(CarriageNoteEdit)} />

          {/* menu redirects */}
          <Route path='/auditLog' element={requireLogin(AuditLog)} />
          <Route path='*' element={<Home />} />
        </Route>
        <Route path='/printCarriage' exact element={<CarriageList2Print />} />
        <Route path='/printPalette' exact element={<CarriagePaletteList2Print />} />
        <Route path='/printSoldCarriage' exact element={<SoldCarriageList2Print />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
